import { InjectionToken } from '@angular/core';
import { AppMeasurement } from '@cigna/core/interfaces';

export const APP_MEASUREMENT = new InjectionToken<AppMeasurement>('s');

export declare var s: AppMeasurement;

export function appMeasurementFactory(): AppMeasurement {
  if (typeof s !== 'undefined') {
    return s;
  }

  console.warn(
    's not detected, analytics events will be added to queue and loaded later if library appears',
  );
}
